import { createFileRoute } from "@tanstack/react-router";
import { SiteRoute, siteSearch } from "@/components/sites/site-route";

// Sitio público de la empresa, primera página (convex/sites/public.ts).
export const Route = createFileRoute("/_public/s/$slug/")({
  validateSearch: siteSearch,
  component: SiteIndexPage,
});

function SiteIndexPage() {
  const { slug } = Route.useParams();
  const { picks } = Route.useSearch();
  return <SiteRoute slug={slug} picks={picks} />;
}
